import type { Product } from "../Product.js";
import { ProductAvailability } from "../ProductAvailability.js";
import { isShippingLater } from "./isShippingLater.js";

export function getProductAvailability(
	stockAmount: number,
	shippingStartsAt: Product["shippingStartsAt"],
	now: number,
): ProductAvailability {
	if (stockAmount === 0) {
		return ProductAvailability.OutOfStock;
	}
	if (isShippingLater(shippingStartsAt, now)) {
		return ProductAvailability.PreOrder;
	}
	return ProductAvailability.InStock;
}
